/* unplugin-vue-components disabled */import script from "./bread.vue?vue&type=script&lang=ts&setup=true"
export * from "./bread.vue?vue&type=script&lang=ts&setup=true"

import "./bread.vue?vue&type=style&index=0&id=40023550&lang=less&scoped=true"

import exportComponent from "D:\\work\\官网\\songjia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40023550"]])

export default __exports__